// LabelPrint.tsx
import React, { useEffect, useState } from 'react'
import Barcode from '../barcode'
import { QRCodeCanvas } from 'qrcode.react'
import { CONFIG_URL } from 'src/helpers/constants'
import moment from 'moment'

type LabelProps = {
   data: any[]
}

const LabelPrint = React.forwardRef<HTMLDivElement, LabelProps>(({ data }, ref) => {
   // State để lưu short links cho từng item

   console.log('data', data)

   return (
      <div ref={ref} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '24px' }}>
         {data.map((item: any, index: number) => (
            <div
               key={index}
               style={{
                  border: '1px solid #000',
                  padding: '16px',
                  marginBottom: '16px',
                  width: 'calc(100% - 16px)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  pageBreakInside: 'avoid',
                  breakInside: 'avoid'
               }}
            >
               <div
                  style={{
                     flexDirection: 'row',
                     display: 'flex',
                     justifyContent: 'space-between',
                     width: '100%',
                     marginBottom: '6px'
                  }}
               >
                  <div style={{}}>
                     <QRCodeCanvas
                        value={item?.shortLink || item?.linkMockup}
                        level="L" // Giảm mức sửa lỗi: L < M < Q < H
                        size={180}
                        // marginSize={10}
                     />
                  </div>
                  <div
                     style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        flex: 1,
                        marginLeft: 12,
                        marginRight: 12
                     }}
                  >
                     {/* Product */}
                     <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '6px' }}>
                        Product: {item?.product}
                     </div>
                     <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '6px' }}>
                        Products: {item?.products}
                     </div>
                     <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '6px' }}>
                        Services: {item?.services}
                     </div>
                     <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '6px' }}>
                        Quantity: {item?.totalQuantity}
                     </div>
                     {/* Note */}
                     {/* Product */}
                     <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '6px' }}>
                        Created At: {item?.createdAt}
                     </div>
                     <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '6px' }}>Note: {item?.note}</div>
                     {/* DVVC */}
                     <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '6px' }}>
                        DVVC: {item?.deliveryPartner || ''}
                     </div>
                  </div>
                  <div style={{}}>
                     <QRCodeCanvas
                        value={`${CONFIG_URL.DOMAIN}/m-order?id=${item?.id}`}
                        level="L" // Giảm mức sửa lỗi: L < M < Q < H
                        size={180}
                        title="Order Detail info"
                        // marginSize={10}
                     />
                  </div>
               </div>
               <div
                  style={{
                     width: '100%',
                     display: 'flex',
                     flexDirection: 'column',
                     alignItems: 'center',
                     marginTop: '12px'
                  }}
               >
                  <div style={{ marginBottom: '8px', width: '100%', display: 'flex', justifyContent: 'center' }}>
                     <Barcode value={String(item?.sellerOrderId || '').trim()} />
                  </div>
                  <div style={{ fontSize: '22px', fontWeight: 'bold', textAlign: 'center' }}>{item?.sellerOrderId}</div>
               </div>
            </div>
         ))}
      </div>
   )
})

export default LabelPrint
